import { PARTNER_PATH } from '../config/api';
import Http from '../utils/http';
import Partner from '../models/Partner';

const http = new Http();

class PartnerService {
  public getPartners(): Promise<Partner[]> {
    return http.get(PARTNER_PATH)
      .then((response: Response) => {
        if (response.ok) {
          return response.json()
            .then(data => this.mapPartners(data));
        } else {
          throw Error(`${response.status} ${response.statusText}`);
        }
      });
  }

  public getPartner(id: number): Promise<Partner> {
    return http.get(`${PARTNER_PATH}/${id}`)
      .then((response: Response) => {
        if (response.ok) {
          return response.json()
            .then(data => this.mapPartner(data));
        } else {
          throw Error(`${response.status} ${response.statusText}`);
        }
      });
  }

  public addPartner(partner: Partner): Promise<number> {
    return http.post(
      PARTNER_PATH,
      {
        'name': partner.partnerName,
        'expires_at': partner.expirationDate.toISOString(),
        'load_price_components': partner.loadPriceComponents,
        'agent_system_name': partner.agentSystemName,
        'allow_dynamic_price': partner.allowDynamicPrice,
        'composite_purchase_doc': partner.compositePurchaseDoc,
        'enable_skeleton_account': partner.enableSkeletonAccount,
      }
    )
      .then((response: Response) => {
        if (response.ok) {
          return response.json()
            .then(data => data[0]);
        } else {
          return response.text()
            .then((errText: string) => {
              throw Error(`${response.status} ${response.statusText} - ${errText}`);
            });
        }
      });
  }

  public savePartner(partner: Partner): Promise<void> {
    return http.post(
      `${PARTNER_PATH}/${partner.id}`,
      {
        id: partner.id,
        name: partner.partnerName,
        expires_at: partner.expirationDate.toISOString(),
        load_price_components: partner.loadPriceComponents,
        agent_system_name: partner.agentSystemName,
        allow_dynamic_price: partner.allowDynamicPrice,
        composite_purchase_doc: partner.compositePurchaseDoc,
        enable_skeleton_account: partner.enableSkeletonAccount,
      }
    )
      .then((response: Response) => {
        if (response.ok) {
          return response.json()
            .then(data => data);
        } else {
          return response.text()
            .then((errText: string) => {
              throw Error(`${response.status} ${response.statusText} - ${errText}`);
            });
        }
      });
  }

  public deletePartner(id: number): Promise<void> {
    return http.delete(`${PARTNER_PATH}/${id}`)
      .then((response: Response) => {
        if (!response.ok) {
          throw Error(`${response.status} ${response.statusText}`);
        }
      });
  }

  private mapPartner(partner: any): Partner {
    return {
      id: partner.id,
      partnerName: partner.name,
      partnerToken: partner.token,
      expirationDate: new Date(partner.expiresAt),
      loadPriceComponents: partner.loadPriceComponents,
      agentSystemName: partner.agentSystemName,
      allowDynamicPrice: partner.allowDynamicPrice,
      compositePurchaseDoc: partner.compositePurchaseDoc,
      enableSkeletonAccount: partner.enableSkeletonAccount,
    };
  }

  private mapPartners(data: any): Partner[] {
    return data.map((item: any) => this.mapPartner(item));
  }
}

export const partnerService = new PartnerService();



// WEBPACK FOOTER //
// ./src/services/PartnerService.tsx